import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { API_URL } from "../../../../config";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

const OutcomeReport = ({selectedFormId,currentId,data,selectedClientDetails}) => {
  const { t } = useTranslation();
  const initialFormData =   {
    Practitioner_Name: "",
    Referrer_Name: "",
    Client_Name: selectedClientDetails ? `${selectedClientDetails.firstname} ${selectedClientDetails.lastname}` : "",
    Email: "",
    Tel: "",
    OVERALL_LEARNING_SUCCESS: "",
    Demonstrated_ability_CO2: "",
    Abatement_symptoms: "",
    Self_explore_breathing: "",
    Motivation_learning: "",
    Homework_completion: "",
    Acceptance_personal_responsibility: "",
    Client_signup_reason: "",
    Learning_objectives: "",
    Symptoms_deficits: "",
    Learning_hurdles: "",
    Cognitive_changes: "",
    Reduced_anxiety: "",
    New_knowledge_beliefs: "",
    Disengaged_habit_triggers: "",
    Disengaged_motivations: "",
    Self_awareness_mechanics: "",
    Self_awareness_triggers: "",
    Self_awareness_chemistry: "",
    Emotional_desensitization_symptoms: "",
    Emotional_desensitization_experience: "",
    Extinction_dysfunctional_behaviors: "",
    New_breathing_behaviors: "",
    CO2_regulation: "",
    New_motivations: "",
    Reduced_triggered_symptoms: "",
    Reduced_organic_symptoms: "",
    Reduced_mental_symptoms: "",
    Improved_performance: "",
    Extinction_troublesome_behaviors: "",
  }
  const [formData, setFormData] = useState(data?data:initialFormData);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

 const [successModal, setsuccessModal] = useState(false);
    const successToggleModal = () => setsuccessModal(!successModal);
  const [loading, setLoading] = useState(false);
const handleSubmit = (e) => {
  e.preventDefault();
  
  
  const userId = localStorage.getItem("user_id");
  const selectedClient = localStorage.getItem("selectedClient");
  const accessToken = localStorage.getItem("accessToken");

  const client_id = selectedClient === "null" ? userId : selectedClient;

  // Start loader
  setLoading(true);



  // Prepare payload (no need to stringify form_data here)
  const payload = {
    client_id: client_id,
    form_id: selectedFormId, // Ensure this variable is defined
    form_data: JSON.stringify(formData),
    session_id: localStorage.getItem("selectedSession") || null,
  };

  console.log("📤 Sending form payload test:", payload);

  fetch(API_URL + "/forms/trainer/form-submit", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": accessToken,
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((resp) => {
      console.log("✅ Response:", resp);
      if (resp.status) {
        successToggleModal();
        setFormData(initialFormData);
      } else {
        console.error("❌ Upload failed:", resp.message);
        console.log("Upload failed: " + resp.message);
      }
    })
    .catch((err) => {
      console.error("⚠️ Error submitting form:", err);
      console.log("Something went wrong while submitting the form.");
    })
    .finally(() => {
      setLoading(false);
    });
};

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        maxWidth: "1200px",
        margin: "0 auto",
        padding: !data?"20px":"10px",
      border: !data && "1px solid #ccc",
        marginTop: "20px",
      }}
    >
      {/* Responsive CSS */}
      <style>
        {`
          @media (max-width: 900px) {
            div[style*="display: flex"] {
              flex-direction: column !important;
              margin-bottom: 10px !important;
            }
            input {
              width: 100% !important;
              margin-left: 0 !important;
              margin-bottom: 10px !important;
            }
          }
        `}
      </style>

      <h1
        style={{
          textAlign: "center",
          color: "#7d3c98",
          fontSize: "24px",
          marginBottom: "20px",
        }}
      >
        OUTCOME REPORT
      </h1>

      {/* Practitioner & Referrer */}
      <div style={{ display: "flex", marginBottom: "10px" }}>
        <div>
          <span>Practitioner Name: </span>
          <input
            name="Practitioner_Name"
            value={formData.Practitioner_Name}
            onChange={handleChange}
            style={{
              borderBottom: "2px solid #444",
              display: "inline-block",
              width: "300px",
              backgroundColor: "#f1f4ff",
              borderTop: "none",
              borderLeft: "none",
              borderRight: "none",
              outline: "none",
            }}
          />
        </div>
        <div style={{ marginLeft: "20px" }}>
          <span>Referrer Name: </span>
          <input
            name="Referrer_Name"
            value={formData.Referrer_Name}
            onChange={handleChange}
            style={{
              borderBottom: "2px solid #444",
              display: "inline-block",
              width: "300px",
              backgroundColor: "#f1f4ff",
              borderTop: "none",
              borderLeft: "none",
              borderRight: "none",
              outline: "none",
            }}
          />
        </div>
      </div>

      {/* Client Info */}
      <div style={{ display: "flex", marginBottom: "10px" }}>
        <div style={{ width: "40%" }}>
          <span>Client Name: </span>
          <input
            name="Client_Name"
            disabled={Boolean(selectedClientDetails)}
            value={formData.Client_Name}
            onChange={handleChange}
            style={{
              borderBottom: "2px solid #444",
              display: "inline-block",
              width: "230px",
              backgroundColor: "#f1f4ff",
              borderTop: "none",
              borderLeft: "none",
              borderRight: "none",
              outline: "none",
            }}
          />
        </div>
        <div style={{ width: "40%", marginLeft: "20px" }}>
          <span>Email: </span>
          <input
            name="Email"
            value={formData.Email}
            onChange={handleChange}
            style={{
              borderBottom: "2px solid #444",
              display: "inline-block",
              width: "250px",
              backgroundColor: "#f1f4ff",
              borderTop: "none",
              borderLeft: "none",
              borderRight: "none",
              outline: "none",
            }}
          />
        </div>
        <div style={{ width: "20%", marginLeft: "20px" }}>
          <span>Tel: </span>
          <input
            name="Tel"
            value={formData.Tel}
            onChange={handleChange}
            style={{
              borderBottom: "2px solid #444",
              display: "inline-block",
              width: "150px",
              backgroundColor: "#f1f4ff",
              borderTop: "none",
              borderLeft: "none",
              borderRight: "none",
              outline: "none",
            }}
          />
        </div>
      </div>

      {/* Overall Learning Success */}
      <div style={{ marginBottom: "15px" }}>
        <span style={{ fontWeight: "bold" }}>OVERALL LEARNING SUCCESS </span>
        <input
          name="OVERALL_LEARNING_SUCCESS"
          value={formData.OVERALL_LEARNING_SUCCESS}
          onChange={handleChange}
          style={{
            display: "inline-block",
            width: "40px",
            backgroundColor: "#f1f4ff",
            borderBottom: "2px solid #444",
            borderTop: "none",
            borderLeft: "none",
            borderRight: "none",
            outline: "none",
          }}
        />
        <span> (1 - 7, where 1 = no progress and 7 = complete success)</span>
      </div>

      <p style={{ fontWeight: "bold", margin: "10px 0" }}>
        Please rate the following about your client and assign a number between 1 and 7.
      </p>

      {/* Ratings Section */}
      {[
        { label: "Demonstrated ability to detect and regulate CO", sub: "2", name: "Demonstrated_ability_CO2", note: "(1 – 7, where 1 = minimal, and 7 = excellent)" },
        { label: "Abatement of symptoms/deficits", name: "Abatement_symptoms", note: "(1 - 7, where 1 = no abatement, and 7 = symptoms/deficits gone)" },
        { label: "Demonstrated ability to self-explore breathing", name: "Self_explore_breathing", note: "(1 – 7, where 1 = very little, and 7 = excellent)" },
        { label: "Motivation for learning new breathing habits,", name: "Motivation_learning", note: "(1 – 7, where 1 = very low, and 7 = highly motivated)" },
        { label: "Homework assignment completion", name: "Homework_completion", note: "(1 - 7, where 1 = no completions, and 7 = all assignments)" },
        { label: "Acceptance of personal responsibility to learn", name: "Acceptance_personal_responsibility", note: "(1 – 7, where 1 = very poor, and 7 = enthusiastic acceptance)" },
      ].map((item, index) => (
        <div style={{ marginBottom: "5px" }} key={index}>
          <span>{item.label} </span>
          {item.sub && <span style={{ fontSize: "11px", verticalAlign: "sub" }}>{item.sub}</span>}
          <input
            name={item.name}
            value={formData[item.name]}
            onChange={handleChange}
            style={{
              display: "inline-block",
              width: "40px",
              backgroundColor: "#f1f4ff",
              borderBottom: "2px solid #444",
              borderTop: "none",
              borderLeft: "none",
              borderRight: "none",
              outline: "none",
              marginLeft: "5px",
            }}
          />
          <span> {item.note}</span>
        </div>
      ))}

      {/* Textareas Section */}
      {[
        { label: "Why did the client decide to sign-up for breathing learnings services?", name: "Client_signup_reason", height: 80 },
        { label: "What were the specific client- breathing learning objectives? How successful was your client?", name: "Learning_objectives", height: 80 },
        { label: "What were the specific symptoms and/or deficits addressed? How successful was your client?", name: "Symptoms_deficits", height: 80 },
        { label: "Were there learning hurdles? What were they? Were they overcome?", name: "Learning_hurdles", height: 40 },
      ].map((item, index) => (
        <div style={{ marginBottom: "15px" }} key={index}>
          <p style={{ fontStyle: "italic", margin: "10px 0" }}>{item.label}</p>
          <textarea
            name={item.name}
            value={formData[item.name]}
            onChange={handleChange}
            style={{
              height: `${item.height}px`,
              width: "100%",
              backgroundColor: "#f1f4ff",
              borderBottom: "2px solid #444",
              borderTop: "none",
              borderLeft: "none",
              borderRight: "none",
              outline: "none",
            }}
          />
        </div>
      ))}

      <p style={{ fontWeight: "bold", margin: "10px 0" }}>
        Please answer these questions about learning outcomes. Be specific. Write N/A if not relevant.
      </p>

      {/* Remaining Input Questions */}
      {[
        { label: "Cognitive changes & their effects on breathing?", name: "Cognitive_changes", width: 470 },
        { label: "Reduced anxiety about breathing & its effects?", name: "Reduced_anxiety", width: 470 },
        { label: "New knowledge & beliefs about breathing?", name: "New_knowledge_beliefs", width: 495 },
        { label: "Disengaged habit triggers, e.g., exercise?", name: "Disengaged_habit_triggers", width: 507 },
        { label: "Disengaged habit motivations-reinforcements, e.g., feeling in control?", name: "Disengaged_motivations", width: 390 },
        { label: "Self-awareness of breathing mechanics and its effects?", name: "Self_awareness_mechanics", width: 430 },
        { label: "Self-awareness of breathing triggered symptoms/deficits?", name: "Self_awareness_triggers", width: 430 },
        { label: "Self-awareness of deregulated chemistry (hypocapnia)?", name: "Self_awareness_chemistry", width: 430 },
        { label: "Emotional desensitization to breathing mediated symptoms, e.g., dizziness?", name: "Emotional_desensitization_symptoms", width: 380 },
        { label: "Emotional desensitization to breathing experience, e.g., fast breathing?", name: "Emotional_desensitization_experience", width: 380 },
        { label: "Extinction of dysfunctional breathing behaviors, e.g., taking big breaths?", name: "Extinction_dysfunctional_behaviors", width: 370 },
        { label: "New breathing behaviors learned, e.g., allowing the exhale?", name: "New_breathing_behaviors", width: 410 },
        { label: "CO2 regulation in the presence of old triggers (in the field)?", name: "CO2_regulation", width: 445 },
        { label: "New motivations/reinforcements discovered/implemented?", name: "New_motivations", width: 430 },
        { label: "Reduced frequency/severity of breathing triggered symptoms/deficits?", name: "Reduced_triggered_symptoms", width: 380 },
        { label: "Reduced frequency/severity of symptoms triggered by organic conditions, e.g., pain?", name: "Reduced_organic_symptoms", width: 325 },
        { label: "Reduced frequency/severity of symptoms trigger by mental conditions. e.g., panic?", name: "Reduced_mental_symptoms", width: 325 },
        { label: "Improved performance, e.g., testing?", name: "Improved_performance", width: 530 },
        { label: "Extinction of related troublesome behaviors, e.g., self-talk?", name: "Extinction_troublesome_behaviors", width: 430 },
      ].map((item, index) => (
        <div style={{ marginBottom: "5px" }} key={index}>
          <span>{item.label}</span>
          <input
            name={item.name}
            value={formData[item.name]}
            onChange={handleChange}
            style={{
              display: "inline-block",
              width: `${item.width}px`,
              backgroundColor: "#f1f4ff",
              borderBottom: "2px solid #444",
              borderTop: "none",
              borderLeft: "none",
              borderRight: "none",
              outline: "none",
              marginLeft: "5px",
            }}
          />
        </div>
      ))}

     {!data &&  <div className="client-submit-btn">
        <button type="button" onClick={handleSubmit}>
          {loading?t("Submitting..."):t("Submit")}
        </button>
      </div>}
       <Modal
                                                        isOpen={successModal}
                                                        toggle={successToggleModal}
                                                        className="connect-box"
                                                        centered={true}
                                                      >
                                                        <ModalHeader toggle={successToggleModal}>
                                                          <span className="ml-1 roititle font-weight-bold">
                                                            Successfull
                                                          </span>
                                                        </ModalHeader>
                                                        <ModalBody>
                                                          <div className="modal-p">
                                                            <p>Trainer form has been submitted successfully.</p>
                                                          </div>
                                                        </ModalBody>
                                                      </Modal>
    </div>
  );
};

export default OutcomeReport;
